var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    { attrs: { block: _vm.currentStep === "0" } },
    [
      _c(
        "el-steps",
        {
          attrs: {
            active: _vm.currentStep * 1,
            "align-center": "",
            "finish-status": "success",
          },
        },
        [
          _c("el-step", { attrs: { title: "查验保单" } }),
          _c("el-step", { attrs: { title: "查验结果" } }),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "top" },
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "", name: "0" } },
            [
              _c(
                "el-card",
                { staticClass: "u-m-t-20" },
                [
                  _c("avue-form", {
                    attrs: { option: _vm.truthOption },
                    on: { submit: _vm.onSubmit },
                    scopedSlots: _vm._u([
                      {
                        key: "idnos",
                        fn: function (ref) {
                          return [
                            _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t请填写身份证号，多个身份证号请用“,“隔开，一次最多可查询10个身份证号例如：1101XXXXXXXXXXX698,1101XXXXXXXXXXX832\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _c("el-input", {
                              attrs: {
                                rows: 3,
                                placeholder: "请输入身份证号",
                                type: "textarea",
                              },
                              model: {
                                value: _vm.truthData.idnos,
                                callback: function ($$v) {
                                  _vm.$set(_vm.truthData, "idnos", $$v)
                                },
                                expression: "truthData.idnos",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "code",
                        fn: function (ref) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "u-flex u-col-center",
                                staticStyle: { height: "30px" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { "max-width": "80px" },
                                  model: {
                                    value: _vm.truthData.code,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.truthData, "code", $$v)
                                    },
                                    expression: "truthData.code",
                                  },
                                }),
                                _c("el-image", {
                                  staticStyle: {
                                    width: "120px",
                                    height: "40px",
                                    margin: "0 10px",
                                  },
                                  attrs: { src: _vm.imageUrl },
                                }),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      loading: _vm.isLoading,
                                      type: "text",
                                    },
                                    on: { click: _vm.onGetCode },
                                  },
                                  [_vm._v("换一个")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.truthData,
                      callback: function ($$v) {
                        _vm.truthData = $$v
                      },
                      expression: "truthData",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "", name: "1" } },
            [
              _c(
                "el-card",
                { staticClass: "u-m-t-20", attrs: { title: "查验结果" } },
                [
                  _vm.resultData.unit
                    ? _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { column: 2, border: "" },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "企业名称" } },
                            [_vm._v(_vm._s(_vm.resultData.unit.unitName))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "统一信用代码" } },
                            [_vm._v(_vm._s(_vm.resultData.unit.unitCode))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "保单号" } },
                            [_vm._v(_vm._s(_vm.resultData.policyNo))]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      data: _vm.resultData.emps || [],
                      option: _vm.tableOption,
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "u-flex u-row-center u-m-t-30" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onToBack },
                        },
                        [_vm._v("返回上一步")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }